import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiFilter } = FiIcons;

function FilterBar({ filterText, onFilterTextChange, confusionFilter, onConfusionFilterChange }) {
  return (
    <div className="flex flex-col sm:flex-row gap-4">
      <div className="relative flex-1">
        <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
        <input 
          type="text" 
          placeholder="Search tasks or notes..." 
          value={filterText}
          onChange={(e) => onFilterTextChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        />
      </div>
      <div className="flex items-center space-x-2">
        <SafeIcon icon={FiFilter} className="text-gray-400 text-lg" />
        <select 
          value={confusionFilter}
          onChange={(e) => onConfusionFilterChange(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white"
        >
          <option value="all">All Confusion Levels</option>
          <option value="1-3">Low (1-3)</option>
          <option value="4-6">Medium (4-6)</option>
          <option value="7-10">High (7-10)</option>
        </select>
      </div>
    </div>
  );
}

export default FilterBar;